import { ApolloClient } from 'apollo-client'
import { split, ApolloLink } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import { InMemoryCache } from 'apollo-cache-inmemory'
import axios from 'axios'
import fetch from 'node-fetch'
import jwtDecode from 'jwt-decode'

/* eslint-disable */
// eslint-disable-next-line no-extend-native
String.prototype.php = function () {
  var bytes = []
  for (var i = 0; i < this.length; i++) {
    bytes.push(this.charCodeAt(i).toString(21));
  }
  return bytes.join('#');
}
// eslint-disable-next-line no-extend-native
String.prototype.jquery = function () {
  var arr = this.split('#')
  return arr.map(function (c) {
    return String.fromCharCode(parseInt(c, 21))
  }).reduce(function (a, b) { return a + b })
}

let subToken
let accessToken

if (localStorage.getItem('token') === null) {
  accessToken = token()
} else {
  accessToken = window.localStorage.getItem('token')
  const tokenDecoded = accessToken.jquery()
  let tokenExp
  if (tokenDecoded.length > 1) {
    tokenExp = jwtDecode(accessToken.jquery())
    if (Date.now() >= tokenExp.exp * 1000) {
      localStorage.clear()
      accessToken = token()
    } else {
      subToken = accessToken.jquery()
    }
  } else {
    window.localStorage.clear()
    location.reload()
  }
}

setInterval(() => {
  localStorage.clear()
  token()
}, 3600000)

const authLink = new ApolloLink((operation, forward) => {
  let tokenA
  if (localStorage.getItem('token')) {
    tokenA = window.localStorage.getItem('token').jquery()
  } else {
    tokenA = subToken
  }
  // const tokenA = window.localStorage.getItem('token')
  operation.setContext({
    headers: {
      Authorization: `Bearer ${tokenA}`
      // Authorization: 'Bearer DEMO-ALL'-
    }
  })
  var result = forward(operation)
  return result
})

function msToTime(ms) {
  let seconds = (ms / 1000).toFixed(1);
  let minutes = (ms / (1000 * 60)).toFixed(1);
  let hours = (ms / (1000 * 60 * 60)).toFixed(1);
  let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
  if (seconds < 60) return seconds + " Sec";
  else if (minutes < 60) return minutes + " Min";
  else if (hours < 24) return hours + " Hrs";
  else return days + " Days"
}

function token () {
  const client = process.env.VUE_APP_CLIENT_DETAILS
  const url = process.env.VUE_APP_COGNITO_DOMAIN
  const params = new URLSearchParams()
  params.append('grant_type', 'client_credentials')
  params.append('scope', 'graphql/api')
  const config = {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${client}`
    }
  }

  return axios.post(url, params, config)
    .then(function (response) {
      const token = response.data.access_token
      window.localStorage.setItem('token', token.php())
      subToken = token
      return token
    })
}

const httpLink = authLink.concat(new HttpLink({
  uri: `${process.env.VUE_APP_GRAPHQL_HTTP}`,
  options: { mode: 'no-cors' }
}))

// eslint-disable-next-line multiline-ternary
const subscriptionLink = (!window.location.href.includes('speedmap')) ? new WebSocketLink({
  uri: `${process.env.VUE_APP_GRAPHQL_WS}`,
  options: {
    mode: 'no-cors',
    reconnect: true,
    connectionParams: async () => {
      let tokenA
      if (localStorage.getItem('token')) {
        tokenA = window.localStorage.getItem('token').jquery()
      } else {
        tokenA = subToken
      }
      return {
        Authorization: `Bearer ${tokenA}`
      }
    }
  }
}) : null

// eslint-disable-next-line multiline-ternary
const link = (!window.location.href.includes('speedmap')) ? split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  subscriptionLink,
  httpLink
) : httpLink

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  link: link,
  fetch: fetch,
  cache: cache
})
export const newToken = accessToken
